import { QuestionCircleOutlined } from '@ant-design/icons'
import { Radio, Tooltip } from 'antd'
import classNames from 'classnames'
import { useAtom } from 'jotai'
import Router from 'next/router'
import { CDNImage } from '~/components/business/CDNImage'
import { MyForm } from '~/components/ui/MyForm'
import styles from '../AiForm.module.css'
import {
  DEFAULT_OPTIONS,
  modelCodeAtom,
  selectModelAtom,
  styleModelAtom,
} from './atom'
import { AiCreateArtworkModel, modelOptions } from '~/graphqls/types'
import { diceThemeAtom } from './Dice'

export const ModelSelectComp = () => {
  const [selectModel, setSelectModel] = useAtom(selectModelAtom)
  const [, setModelCode] = useAtom(modelCodeAtom)
  const [, setStyleModel] = useAtom(styleModelAtom)
  const [, setDiceTheme] = useAtom(diceThemeAtom)

  return (
    <MyForm.Item
      label={
        <span>
          * 模型选择{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="通用模型是一种广泛适用的模型，可应用于不同的领域，具有较高的通用性和灵活性；漫画模型专门用于生产漫画动漫相关的内容；风格模型具有特定的风格，对风格具有很好的稳定性；MJ模型擅长解释自然语言，风格多样化"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      }
      className={classNames(styles.borderLessFormItem, '!mb-8')}
    >
      <Radio.Group
        className={styles.customRadioGroup}
        onChange={e => {
          setSelectModel(e.target.value)
          setStyleModel(null)
          // 备注：重置modelCode是为了不想风格模型切换到二次元/通用模型的时候，选中风格模型的原始模型
          if (
            e.target.value === AiCreateArtworkModel.STYLE ||
            selectModel === AiCreateArtworkModel.STYLE
          ) {
            setModelCode(DEFAULT_OPTIONS.MODEL_CODE)
          }
        }}
        value={selectModel}
      >
        {modelOptions.map(item => {
          const checked = selectModel === item.model
          return (
            <Radio
              value={item?.model}
              key={item?.model}
              className={classNames(
                styles.customRadio,
                checked ? '!flex-[2_1_0%]' : 'flex-1',
                '!mb-0'
              )}
              onClick={e => {
                // 产品需求：https://www.tapd.cn/57191511/prong/stories/view/1157191511001030740
                // 用户点击主题时，魔法骰子主题切换为第一个
                // 跳过mj，mj会自动锁定mj分类
                if (
                  [
                    AiCreateArtworkModel.STABLE_DIFFUSION,
                    AiCreateArtworkModel.ANIME_DIFFUSION,
                    AiCreateArtworkModel.STYLE,
                  ].includes(item.model)
                ) {
                  setDiceTheme(0)
                  return
                }
              }}
            >
              <div>
                <div
                  className={classNames(
                    'flex relative items-center justify-between cursor-pointer mt-2 py-3 h-[104px] border-2 border-solid border-neutral-200 rounded-xl bg-neutral-200',
                    checked ? 'px-4' : 'px-0',
                    styles.radioBtn,
                    styles.modelBg
                  )}
                >
                  {item.tag && item.model !== 'MIDJOURNEY' && (
                    <div className="absolute top-1 right-1 p-1 rounded-full text-center bg-error text-neutral-900 text-[12px] leading-none scale-[0.83]">
                      {item.tag}
                    </div>
                  )}
                  <div
                    className={classNames('flex-1 transition-all', {
                      'text-center': !checked,
                    })}
                  >
                    <div className="text-neutral-800 font-semibold">
                      {item?.name}
                    </div>
                    <div className="text-neutral-500 text-xs">{item?.desc}</div>
                  </div>
                  {checked && (
                    <div className="w-20 h-20">
                      <img src={item.url || ''} alt={item.name!} />
                    </div>
                  )}
                </div>
                {item.model === 'MIDJOURNEY' && (
                  <Tooltip
                    className="absolute top-2 right-0 mr-2 mt-[6px]"
                    placement="topRight"
                    arrowPointAtCenter
                    overlayStyle={{ minWidth: '287px' }}
                    title={
                      <div className=" text-white">
                        此模型仅限VIP会员专享使用{' '}
                        <span
                          className="text-primary cursor-pointer"
                          onClick={() => {
                            Router.push('/member')
                          }}
                        >
                          立即开通VIP →
                        </span>
                      </div>
                    }
                    getPopupContainer={() =>
                      document.getElementById('icon') as HTMLElement
                    }
                  >
                    <div id="icon">
                      <CDNImage
                        className="h-[16px]"
                        src="/images/ai/vip_tips2.png"
                      />
                    </div>
                  </Tooltip>
                )}
              </div>
            </Radio>
          )
        })}
      </Radio.Group>
    </MyForm.Item>
  )
}
